import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';

export default function coalesceGlobalErrorMessage(
  errorMessage: string,
  additionalErrorMessages?: Record<string, string>
): string {
  return (
    additionalErrorMessages?.[errorMessage] || GLOBAL_ERROR_MESSAGE[errorMessage] || errorMessage
  );
}
